import { render } from "./AboutPthGjilan.vue?vue&type=template&id=6ede941c&scoped=true"
import script from "./AboutPthGjilan.vue?vue&type=script&lang=js"
export * from "./AboutPthGjilan.vue?vue&type=script&lang=js"

import "./AboutPthGjilan.vue?vue&type=style&index=0&id=6ede941c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ede941c"]])

export default __exports__